<script lang="ts">
// Content is directly controlled by developers.
/* eslint-disable vue/no-v-html */
</script>

<script setup lang="ts">
import {
  floorFitness,
  floorOther,
  textFitness,
  textOther,
} from '~/components/footer/content/contact';

function getOpeningHours(
  t1: string,
  t2: string,
  t3: string,
  t4: string,
  t5: string,
  t6: string,
  holidays = '',
) {
  return `<p>Po-Pá:&nbsp;${t1}&nbsp;-&nbsp;${t2}${' <span class="text-client-orange">' + holidays + '</span>'}</p><p>So-Ne&nbsp;+&nbsp;svátky:&nbsp;${t3}&nbsp;-&nbsp;${t4}&nbsp;/&nbsp;${t5}&nbsp;-&nbsp;${t6}</p>`;
}

const title = 'Aktuální otevírací doba';
const hoursFitness = getOpeningHours(
  '7:00',
  '21:30',
  '9:00',
  '12:00',
  '14:00',
  '21:00',
  '(Letní prázdniny do 21:00!)',
);
const hoursOther = getOpeningHours(
  '7:30',
  '22:00',
  '9:00',
  '12:00',
  '14:00',
  '21:00',
);
</script>

<template>
  <article
    class="text-client-white px-r6 gap-r4 py-r5 bg-client-black/50 shadow-client-black/25 right-r4 sm:right-r12 lg:right-r18 bottom-r12 flex flex-col rounded-lg shadow-[0px_4px_4px_0px] lg:absolute"
  >
    <AppHeading tag="h5">
      {{ title }}
    </AppHeading>
    <AppParagraph class="text-client-orange font-medium! lg:max-w-xs">
      <AppText size="md" class="underline">
        {{ floorFitness }}
      </AppText>
      {{ textFitness }}
    </AppParagraph>
    <div v-html="hoursFitness"></div>
    <AppParagraph class="text-client-orange font-medium! lg:max-w-xs">
      <AppText size="md" class="underline">
        {{ floorOther }}
      </AppText>
      {{ textOther }}
    </AppParagraph>
    <div v-html="hoursOther"></div>
  </article>
</template>
